import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ejemplo-colores',
  templateUrl: './ejemplo-colores.component.html',
  styleUrls: ['./ejemplo-colores.component.scss']
})
export class EjemploColoresComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
